import axios from "axios"
import {getAxiosConfigWithAuth} from "../../utils/auth"
import {Work} from "./Work"

export default class WorkEntityService {
	public async getLastWorkRevision(workId: string): Promise<Work | null> {
		const res = await axios
			.get(
				`${
					process.env.REACT_APP_WORK_ENTITY_SERVICE_URL
				}/api/v1/works/${workId}?includeHidden=true&from=${"care-console"}`,
				getAxiosConfigWithAuth()
			)
			.then((res) => {
				return res.data as Work
			})
			.catch((e) => {
				console.error(e)
				return null
			})
		return res
	}
	public async getAllWorkRevisions(workId: string): Promise<Work[] | null> {
		return axios
			.get(
				`${process.env.REACT_APP_WORK_ENTITY_SERVICE_URL}/api/v1/works/${workId}/revisions?includeHidden=false&from=care-console`,
				getAxiosConfigWithAuth()
			)
			.then((res) => res.data as Work[])
			.catch((e) => {
				console.error(e)
				return null
			})
	}
}

export const WorkEntityServiceDependency = new WorkEntityService()
